import {
  useGridApiContext,
  gridVisibleColumnDefinitionsSelector,
  gridColumnsTotalWidthSelector,
  GRID_CHECKBOX_SELECTION_FIELD,
} from '@mui/x-data-grid-pro';
import { DEFAULT_ROW_HEIGHT, INIT_SKELETON_ROWS_COUNT } from '../../../constants';
import { Skeleton } from '@nexelem/components';

export const TableLoadingOverlay = () => {
  const apiRef = useGridApiContext();
  const visibleColumns = gridVisibleColumnDefinitionsSelector(apiRef);
  const totalWidth = gridColumnsTotalWidthSelector(apiRef);

  return (
    <div className="flex flex-col" style={{ width: `${totalWidth}px` }}>
      {Array.from({ length: INIT_SKELETON_ROWS_COUNT }, (_, rowIndex) => (
        <div className="flex" key={rowIndex} style={{ height: `${DEFAULT_ROW_HEIGHT}px` }}>
          {visibleColumns.map((column, columnIndex) => {
            const align = column.align || 'left';
            const hasHeaderName = column.headerName || column.renderHeader;
            const customStatus = column.field === 'status-custom';
            const isCheckboxColumn = column.field === GRID_CHECKBOX_SELECTION_FIELD;
            const columnWidth = column.computedWidth || 100;

            return (
              <div
                className="box-border flex items-center px-2"
                key={`${rowIndex}-${columnIndex}`}
                style={{ width: `${columnWidth}px`, justifyContent: align }}
              >
                {customStatus && (
                  <div className="box-border aspect-square max-h-6 w-6">
                    <Skeleton className="h-full rounded-full" />
                  </div>
                )}
                {isCheckboxColumn && <Skeleton className="ml-2 size-4.5" />}
                {hasHeaderName && !isCheckboxColumn && (
                  <Skeleton className="h-6" style={{ width: `${(columnWidth || 100) * 0.8}px` }} />
                )}
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
};
